var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy row"},[_vm._v(" Copyright ©2023. All Rights Reserved By "),_c('a',{staticClass:"peak",attrs:{"href":"https://site.peaklinkdemo.com/"}},[_vm._v(" Peak Link")])])
}]

export { render, staticRenderFns }